<template>
    <div class="w-full h-screen flex items-center bg-white text-black">
        <div class="m-auto" :class="loading ? 'pulse' : 'fade-out'">
<!--            <picture>-->
<!--                <source type="image/webp"  srcset="img/adirex_loader.webp">-->
<!--                <source srcset="img/adirex_loader.png">-->
<!--                <img src="img/adirex_loader.png" alt="Adirex">-->
<!--            </picture>-->
            <div class="shadow w-full bg-black">
                <div class="bg-black text-xs leading-none text-center text-white" style="height: 1px"
                     :style="'width:'+ percent+'%'"></div>
            </div>
            <div class="text-center text-xs text-black">{{percent}}%</div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'preloader',
        props: {

        },
        data() {
            return {
                loading: true,
                loaded: 0,
                preload_images:[]
            }
        },
        computed: {
            percent() {
                if(!this.images.length){
                  return 0;
                }
                return Math.round((this.loaded / this.images.length) * 100);
            },
            images(){
                //console.log(window.webp);
                if(window.webp){
                    // return  this.images_settings.map((img)=>{
                    //     return img.slice(0, -3) + 'webp';
                    // });
                }
                return this.preload_images;
            }
        },
        methods: {
            hide() {
                this.loading = false;
                setTimeout(() => {
                    this.$emit('loaded')
                }, 1000);
            },
            preloadImages() {
                if(!this.images.length){
                    this.hide();
                }
                for (let i = 0; i < this.images.length; i++) {
                    let image = new Image()
                    image.src = this.images[i];
                    image.onload = () => {
                        this.loaded++;
                        //console.log(this.loaded);
                        if (this.loaded >= this.images.length) {
                            this.hide();
                        }
                    }
                }
            },
            loadInitialData(){
              this.$store.dispatch('init').then(()=>{
                this.preload_images = this.$store.getters.getFeaturedProjectsImages;
                this.preloadImages()
              });
            }
        },
        mounted() {
            this.loadInitialData();
        }
    }
</script>
